<template>
  <div class="container file-view">
    <confirm-dialog
      v-model="deleteFileDialog"
      @confirmed="deleteFile"
    ></confirm-dialog>

    <app-modal v-model="uploadVideoDialog" title="Upload Video">
      <file-form
        v-model="file"
        :file-to-upload="fileToUpload"
        :selected-file-id="selectedFileId"
        :project-id="$route.params.projectID"
        :active="uploadVideoDialog"
        @updated="updatedFile"
        @start-upload="startUpload"
        @upload-end="uploadEnd"
      ></file-form>
    </app-modal>

    <upload-progress v-model="filesUploading"></upload-progress>
    <download-progress v-model="downloadingFile"></download-progress>

    <page-header :title="pagetitle">
      <template v-slot:right>
        <div class="level">
          <div class="level-item">
            <!--button class="button" @click="uploadFileDialog = true">
              <span class="icon icon-edit"></span>
              <span>Edit</span>
            </button-->
          </div>
          <div class="level-item">
            <!--<button class="button disablable" @click="selectedFileId = null; deleteFileDialog = true;" :disabled="checkedVideos.length <= 0">
              <span class="icon icon-delete"></span>
              <span>Delete</span>
            </button>-->
          </div>
          <div class="level-item">
            <!--<button class="button disablable" @click="downloadMultiple" :disabled="checkedVideos.length <= 0">
              <span class="icon icon-download"></span>
              <span>Download</span>
            </button>-->
          </div>
        </div>
      </template>
    </page-header>

    <div
      id="playerAndSidebar"
      ref="playerAndSidebar"
      :style="{
        display: projectLiveStreamsAndVideos.length > 0 ? 'flex' : 'none'
      }"
    >
      <div id="playerlavQgaIqHoiO"></div>
      <div id="listbar" v-bind:style="listbarStyle">
        <app-table
          :items="projectLiveStreamsAndVideos"
          :headers="headers"
          :expanded-item="expandedItem"
          @click:row="displayVideo($event.fileID, $event)"
        >
          <template v-slot:item.checked="{ item }">
            <button
              class="button is-icon is-text checkbox-button"
              @click.stop="toggleCheck(item)"
            >
              <img
                v-if="!item.checked"
                src="../../assets/images/checkbox-unchecked.svg"
              />
              <img
                v-if="item.checked"
                src="../../assets/images/checkbox-checked.svg"
              />
            </button>
          </template>

          <template v-slot:item.name="{ item }">
            <!-- Video name and date -->
            <div v-if="item.isVOD">
              {{ item.name }}<br />
              {{ item.createdOnUTC | toDateStr }}
            </div>
            <div v-if="item.isLiveStream">
              Live Stream<br />
              {{ item.name }}
            </div>
          </template>

          <template v-slot:item.actions="{ item }">
            <!-- Edit Button -->
            <button
              v-if="item.isVOD && hasPermission([40002, 40001])"
              class="button is-text is-icon"
              @click.stop="openEditDialog(item)"
            >
              <span class="icon icon-edit"></span>
            </button>

            <!-- Delete Button -->
            <button
              v-if="
                item.isVOD &&
                  hasPermission([40002, 40001]) &&
                  (item.uploadProgress === undefined ||
                    item.uploadProgress === 100)
              "
              class="button is-text is-icon"
              @click.stop="
                () => {
                  selectedFileId = item.fileID;
                  deleteFileDialog = true;
                }
              "
            >
              <span class="icon icon-delete"></span>
            </button>

            <!-- Download Button -->
            <button
              v-if="
                item.isVOD &&
                  item.processingStatus != 'Uploaded' &&
                  item.processingStatus != 'Processing' &&
                  item.processingStatus != 'Failed'
              "
              class="button is-text is-icon"
              @click.stop="downloadVideoFromS3(item)"
            >
              <span class="icon icon-download"></span>
            </button>

            <!-- Expand Button 
            <button
              v-if="
                item.uploadProgress === undefined || item.uploadProgress === 100
              "
              class="button is-text is-icon"
              @click.stop="
                () => {
                  if (item.fileID !== expandedItem) {
                    expandedItem = item.fileID;
                  } else {
                    expandedItem = -1;
                  }
                }
              "
            >
              <img
                id="down-arrow"
                v-if="item.description"
                src="../../assets/images/arrow-down.svg"
                :style="
                  item.fileID === expandedItem
                    ? 'transform: rotate(180deg); transition: .3s ease-in-out;'
                    : 'transform: rotate(0deg); transition: .3s ease-in-out;'
                "
              />
            </button>-->

            <!-- Upload Spinner -->
            <span
              v-if="
                item.processingStatus == 'Uploaded' ||
                  item.processingStatus == 'Processing'
              "
              class="upload-spinner"
            >
              {{ item.uploadProgress }}
            </span>
          </template>
        </app-table>
      </div>
    </div>
  </div>
</template>

<script>
import AppTable from '@/components/AppTable.vue';
import PageHeader from '@/components/PageHeader.vue';
import ConfirmDialog from '../../components/ConfirmDialog';
import FileForm from '@/components/forms/FileForm';
import AppModal from '@/components/AppModal';
import _ from 'lodash';
import { CognitoIdentityCredentials, config, S3 } from 'aws-sdk';
import FilesHelper from '@/mixins/Files.js';
import UploadProgress from '@/components/UploadProgress';
import DownloadProgress from '@/components/DownloadProgress';

// S3 properties
const bucketName = 'vida-vod';
const bucketRegion = 'us-west-2';
const identityPoolId = 'us-west-2:cb03d30c-2a41-48ae-9e34-bb1898375c0f';

export default {
  name: 'VideoShow',
  components: {
    AppTable,
    PageHeader,
    ConfirmDialog,
    FileForm,
    AppModal,
    UploadProgress,
    DownloadProgress
  },
  mixins: [FilesHelper],
  data() {
    return {
      intervalId: null,
      project: { projectID: -1 },
      projectFiles: [],
      deleteFileDialog: false,
      selectedFileId: -1,
      selectedLiveStreamDex: -1,
      file: {},
      fileToUpload: {},
      liveStreams: [],
      headers: [
        /*
        {
          text: '',
          value: 'checked',
          align: 'left',
          class: 'checkbox-td'
        },
        */
        {
          text: '',
          value: 'name',
          align: 'left'
        },
        {
          text: '',
          value: 'actions',
          align: 'right',
          width: 160
        }
      ],
      uploadVideoDialog: false,
      expandedItem: -1,
      listbarStyle: {}
    };
  },
  computed: {
    projectVideos: function() {
      return this.projectFiles
        .filter(file => {
          return file.fileType === 'Video';
        })
        .map(video => {
          //const videoName = video.fileName.replace(/\.[^/.]+$/, '');
          const fileKey = video.fileKey.split('/');
          const videoName = fileKey[fileKey.length - 1].replace(
            /\.[^/.]+$/,
            ''
          );
          const videoKey = this.buildS3VideoPlaybackKey(
            this.project.projectID,
            videoName
          );
          video.url = 'https://drt6ia7p5jxun.cloudfront.net/' + videoKey;
          video.isLiveStream = false;
          video.isVOD = true;
          return video;
        });
    },
    projectLiveStreams: function() {
      return this.liveStreams
        .filter(liveStream => {
          return liveStream.projectID === this.project.projectID;
        })
        .map(liveStream => {
          liveStream.isLiveStream = true;
          liveStream.isVOD = false;
          // Build a URL for playing the live stream.  This must correspond with the URL generated by the backend
          // and assigned as the output destination by AWS Elemental MediaLive.
          let liveStreamURL =
            'https://vzulltxm4yktal.data.mediastore.us-west-2.amazonaws.com/';
          const urlProjectName = this.project.name.toLowerCase().replace(/\W/g, '');
          const urlLabName = liveStream.name.toLowerCase().replace(/\W/g, '');
          liveStreamURL +=
            urlProjectName +
            '_' +
            this.project.projectID +
            '/' +
            urlLabName +
            '/main.m3u8';
          liveStream.url = liveStreamURL;

          return liveStream;
        });
    },
    projectLiveStreamsAndVideos: function() {
      const streamsAndVideos = this.projectLiveStreams.concat(
        this.projectVideos
      );
      return streamsAndVideos;
    },
    checkedVideos: function() {
      return this.projectVideos.filter(video => video.checked === true);
    },
    pagetitle: function() {
      if (
        this.file &&
        this.file.name &&
        this.selectedFileId != -1 &&
        this.selectedFileId != null
      ) {
        return this.file.name;
      } else {
        if (this.selectedLiveStreamDex != -1) {
          const stream = this.projectLiveStreams[this.selectedLiveStreamDex];
          return 'Live Stream: ' + stream.name;
        }
      }
    }
  },
  created() {
    window.addEventListener("resize", this.updateListbarHeight);
  },
  mounted() {
    // Create an AWS Cognito identity pool with permissions to write to
    // the S3 bucket
    config.update({
      region: bucketRegion,
      credentials: new CognitoIdentityCredentials({
        IdentityPoolId: identityPoolId
      })
    });

    // Fetch the current project from the server now, and then periodically.
    // This will allow us to show activity indicators when a video is
    // uploading or processing.
    this.axiosRequest('get', `Projects/${this.$route.params.projectID}`).then(
      response => {
        this.project = response.data;
        // Then fetch the current project's Files from the server
        this.loadLiveStreamsAndVideos(this, this.initVideoPlayer);
      }
    );
    this.intervalId = setInterval(() => {
      // Reload our list only if a video is not playing.  Otherwise the updates can be distracting.
      if (
        jwplayer()
          .getState()
          .toLowerCase() != 'playing'
      ) {
        this.loadLiveStreamsAndVideos(this, null);
        // Re-load the playlist only if we are confident something has changed.
        // This causes the video player to reset.  We might want to save and re-apply
        // video player state before doing this.
        const newplaylist = this.projectLiveStreamsAndVideos.map(video => {
          return {
            file: video.url,
            title: video.name
          };
        });
        const newURLS = newplaylist.map(x => {
          return x.url;
        });
        const oldURLS = jwplayer()
          .getPlaylist()
          .map(x => {
            return x.url;
          });
        if (JSON.stringify(newURLS) != JSON.stringify(oldURLS)) {
          jwplayer().load(newplaylist);
        }
      }
    }, 10 * 1000);
  },
  destroyed() {
    if (this.intervalId) clearInterval(this.intervalId);
    window.removeEventListener("resize", this.updateListbarHeight);
  },
  methods: {
    displayVideo(videoID, item) {
      if (videoID) {
        // Play the selected video on demand
        const selectionIndex = this.projectLiveStreamsAndVideos.findIndex(
          video => video.fileID === videoID
        );
        jwplayer().playlistItem(selectionIndex);
        const selectedVideoIndex = this.projectVideos.findIndex(
          video => video.fileID === videoID
        );
        if (selectedVideoIndex > -1) {
          this.file = this.projectVideos[selectedVideoIndex];
          this.selectedFileId = this.file.fileID;
          this.selectedLiveStreamDex = -1;
        }
      } else if (item) {
        // Play the selected live stream
        const selectionIndex = this.projectLiveStreamsAndVideos.findIndex(
          streamorvideo => streamorvideo === item
        );
        const selectedLiveStreamIndex = this.projectLiveStreams.findIndex(
          stream => stream == item
        );
        if (selectedLiveStreamIndex != -1) {
          this.file = {};
          this.selectedFileId = -1;
          this.selectedLiveStreamDex = selectedLiveStreamIndex;
        }

        jwplayer().playlistItem(selectionIndex);
      }
    },
    deleteFile() {
      if (this.selectedFileId) {
        this.axiosRequest('delete', `Files/${this.selectedFileId}`)
          .then(() => {
            const idx = _.findIndex(this.projectFiles, {
              fileID: this.selectedFileId
            });
            this.projectFiles.splice(idx, 1);
            this.deleteFileDialog = false;
          })
          .catch(error => {
            this.showErrorMessage(error);
          });
      } else {
        this.deleteMultiple();
        this.selectedFileId = null;
      }
    },
    downloadVideo(file) {
      //this might need to change to use the download progress component...but it will be a bit slower since it will ask on the API then it goes to the S3...so not changing it right now
      const fileName = file.fileName;
      const videoKey = file.fileKey;
      // The upload key references the raw file that was uploaded.
      /*const videoKey = this.buildS3VideoUploadKey(
        this.project.projectID,
        fileName
      );*/
      const s3 = new S3({ params: { Bucket: bucketName } });
      const params = { Bucket: bucketName, Key: videoKey };
      s3.getObject(params, (err, data) => {
        const blob = new Blob([data.Body], { type: data.ContentType });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
    },
    openEditDialog(item) {
      this.fileToUpload = { name: item.fileName };
      this.file = item;
      this.file.organizationTags = _.chain(item.tags)
        .reject({
          isSystemTag: true
        })
        .map('name')
        .value();
      this.file.systemTags = _.chain(item.tags)
        .filter({
          isSystemTag: true
        })
        .map('name')
        .value();
      this.selectedFileId = item.fileID;
      this.uploadVideoDialog = true;
    },
    closeFilePopup(projectFiles) {
      this.projectFiles = projectFiles;
      this.uploadVideoDialog = false;
      this.file = {};
      this.fileToUpload = {};
    },
    loadLiveStreamsAndVideos(thevue, callback) {
      thevue
        .axiosRequest(
          'get',
          `Projects/${thevue.$route.params.projectID}/VideoLiveStreams`
        )
        .then(response => {
          this.liveStreams = response.data;
        })
        .then(result => {
          thevue
            .axiosRequest(
              'get',
              `Projects/${thevue.$route.params.projectID}/Files`
            )
            .then(response => {
              thevue.projectFiles = response.data;
            })
            .then(result => {
              if (callback) {
                callback(thevue, result);
              }
            });
        });
    },
    initVideoPlayer(thevue) {
      // Initialize and configure the JWPlayer object
      jwplayer('playerlavQgaIqHoiO').setup({
        playlist: thevue.projectLiveStreamsAndVideos.map(x => {
          return {
            file: x.url,
            title: x.name
          };
        }),
        aspectratio: '16:9',
        autostart: 'false',
        fallback: false,
        mute: false,
        primary: 'html5',
        hlshtml: true,
        id: 'stream-tester-player-https',
        nextUpDisplay: false,
        logo: {}
      });

      thevue.displayVideo(thevue.$route.params.videoId, null);
      this.updateListbarHeight();
    },
    toggleCheck(item) {
      const checkedItem = this.projectFiles.find(
        video => video.fileID === item.fileID
      );
      this.$set(checkedItem, 'checked', !checkedItem.checked);
    },
    deleteMultiple() {
      this.checkedVideos.forEach(video => {
        this.selectedFileId = video.fileID;
        this.deleteFile();
      });
    },
    downloadMultiple() {
      this.checkedVideos.forEach(video => {
        this.downloadVideo(video);
      });
    },

    /*updatedFile(file) {
      this.fileToUpload = null;
      this.uploadVideoDialog = false;
    }*/
    updatedFile(file) {
      console.log('updatedFile', file);
      //this.closeFilePopup();
      this.uploadVideoDialog = false;
      const idx = _.findIndex(this.projectFiles, {
        fileID: this.selectedFileId
      });
      if (idx != -1) {
        this.$set(this.projectFiles, idx, file);
      }
    },
    updateListbarHeight() {
      // Update listbar height to match video height
      // Video width is 2/3 of container minus 1% padding; video aspect ratio is 16:9
      // Can't access video player height directly because it's initialized late
      const videoWidth = this.$refs.playerAndSidebar.clientWidth * ((2/3) - .01);
      const heightString = (videoWidth * (9/16)) + 'px';
      this.$set(this.listbarStyle, 'height', heightString);
    }
  }
};
</script>

<style lang="scss">
#header-level {
  margin-bottom: 3rem;

  .title {
    margin-left: 3rem;
  }
}

#playerAndSidebar {
  display: flex;
  flex-direction: row;
}

#playerlavQgaIqHoiO {
  display: flex;
  flex: 2;
  height: 100% !important;
}

#listbar {
  display: flex;
  flex: 1;
  padding-left: 1.5%;
  overflow-y: scroll;

  .app-table-header-wrapper {
    height: 0;
  }

  .cell {
    padding: 0 2rem;
    display: flex;
  }

  .checkbox-td {
    width: 60px;

    .cell {
      padding-right: 10px;
    }
  }

  .scrollbar {
    min-height: 400px;
  }
  @media (min-width: 1216px) {
    .scrollbar {
      min-height: 426px;
    }
  }
  @media (min-width: 1408px) {
    .scrollbar {
      min-height: 496px;
    }
  }
}

#down-arrow {
  width: 20px;
}

.disablable[disabled],
.disablable[disabled]:hover {
  background: rgba(196, 196, 196, 0.1) !important;
  opacity: 0.5;
}

.checkbox-button {
  min-width: 2.5rem;
  display: none !important;
}
</style>
